import React from 'react';
import { format, parseISO } from 'date-fns';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import moment from 'moment';

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#1F4E79',
    borderBottomWidth: 1,
    borderBottomColor: '#D9E2EC',
    paddingBottom: 4,
    marginBottom: 7,
  },
  normal: {
    borderStyle: 'solid',
    borderColor: '#CBD5E1',
    borderWidth: 1,
    borderRadius: 3,
    backgroundColor: '#F8FAFC',
    padding: 7,
    width: '100%',
    marginTop: 3,
    lineHeight: 1.35,
  },
  subtitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#334E68',
  },
  datetime: {
    fontSize: 9,
    color: '#627D98',
    marginBottom: 5,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#BCCCDC',
    paddingBottom: 10,
    marginBottom: 14,
  },
  logo: {
    width: 52,
    height: 52,
    objectFit: 'contain',
  },
  headerText: {
    flexGrow: 1,
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#1F4E79',
    marginBottom: 4,
  },
  headerSubtitle: {
    fontSize: 10,
    color: '#486581',
  },
});

export const RequestHeader = ({ ocurrence, ...props }) => {
  return (
    <View fixed style={styles.header}>
      <Image source={require('../../../../asset/logo.png')} style={styles.logo} />
      <View style={styles.headerText}>
        <Text style={styles.headerTitle}>Ocorrência: {ocurrence.protocolo}</Text>
        <Text style={styles.headerSubtitle}>Solicitante: {ocurrence.solicitante.nome}</Text>
      </View>
    </View>
  );
};

export const RequestInformation = ({ ocurrence, ...props }) => {
  return (
    <View style={styles.container}>
      <Text style={[styles.title, { marginTop: 10 }]}>Informações</Text>
      <View>
        <View style={styles.row}>
          <Text style={[styles.normal, { fontSize: 12 }]}>Solicitante: {ocurrence.solicitante.nome}</Text>
        </View>
        <View>
          <Text style={[styles.normal, { fontSize: 12 }]}>
            Aberta em:{' '}
            {ocurrence
              ? `${new Date(ocurrence.abertura).toLocaleDateString()} às ${new Date(
                ocurrence.abertura,
              ).toLocaleTimeString()}`
              : 'Não informado'}
          </Text>
        </View>
        {ocurrence.coletivo ? (
          <View>
            <Text style={{ fontSize: 12 }}>Secundários: </Text>
            <Text style={{ fontSize: 12 }}>{ocurrence.coletivo}</Text>
          </View>
        ) : null}
      </View>
    </View>
  );
};

export const RequestLocation = ({ ocurrence, ...props }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Localização</Text>
      <Text style={[styles.normal, { fontSize: 12 }]}>{ocurrence.endereco}</Text>
    </View>
  );
};

export const RequestTriage = ({ ocurrence, ...props }) => {
  return (
    <View style={styles.container}>
      <View>
        <View>
          <Text style={styles.title}>Dados da Triagem</Text>
        </View>
      </View>

      <View>
        <View>
          <Text style={[styles.normal, { fontSize: 12 }]}>Categoria: {ocurrence.categoria}</Text>
        </View>
        <View>
          <Text style={[styles.normal, { fontSize: 12 }]}>Entrada: {ocurrence.entrada}</Text>
        </View>
        <View>
          <Text style={[styles.normal, { fontSize: 12 }]}>Gravidade: {ocurrence.gravidade ?? 'Não Informado'}</Text>
        </View>
        <View>
          <Text style={[styles.normal, { fontSize: 12 }, { marginTop: 2 }]}>
            Setor: {ocurrence.setor ?? 'Não Informado'}
          </Text>
        </View>
      </View>
    </View>
  );
};

export const RequestDescription = ({ ocurrence, ...props }) => {
  return (
    <View style={styles.container}>
      <View>
        <Text style={styles.title}>Solicitação</Text>
      </View>
      <View>
        <Text style={[styles.normal, { fontSize: 12 }]}>Protocolo: {ocurrence.protocolo}</Text>
      </View>
      <View>
        <Text style={[styles.title, { marginTop: 20 }, { marginBottom: 10 }]}>Assunto: </Text>
      </View>
      <View>
        <Text style={[styles.normal, { fontSize: 12, color: 'grey' }]}>
          {ocurrence.tema}/{ocurrence.assunto}/<Text style={{ color: 'black' }}>{ocurrence.servico}</Text>
        </Text>
      </View>
      <View>
        <Text style={[styles.normal, { fontSize: 12 }]}>Descrição:{ocurrence.descricao}</Text>
      </View>
    </View>
  );
};

export const RequestCommunication = ({ communication, pos, ...props }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        Mensagens. Solicitação de Informação #{pos + 1} (Aberta em:
        {communication ? format(parseISO(communication.created_at), 'dd/MM/yyyy hh:mm:ss') : 'Não informado'})
      </Text>
      <View>
        <Text style={[styles.normal, { fontSize: 12 }]}>Pergunta: {communication.pedido}</Text>
      </View>
      <View>
        <Text style={[styles.normal, { fontSize: 12 }]}>Resposta: {communication.resposta}</Text>
      </View>
    </View>
  );
};

export const RequestRedirect = ({ movement, ...props }) => {
  return (
    <View style={styles.container}>
      <View>
        <View>
          <Text style={styles.title}>Encaminhamento</Text>
          <Text style={styles.datetime}>{moment(movement.inicio).format('DD/MM/YYYY HH:mm:ss')}</Text>
        </View>
      </View>
      <View>
        <Text style={[styles.normal, { fontSize: 12 }]}>Destino: {movement.destinatario}</Text>
      </View>
    </View>
  );
};

export const RequestAnswer = ({ movement, json, ...props }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Resposta</Text>
      <Text style={styles.datetime}>{moment(movement.inicio).format('DD/MM/YYYY HH:mm:ss')}</Text>
      {json.compete === 'N' ? (
        <View>
          <Text style={{ fontSize: 12 }}>Compete a Outro Departamento: </Text>
          <Text style={{ fontSize: 12 }}>{json.departamento}</Text>
        </View>
      ) : (
        <View>
          {json.envolvedepto === 'S' ? (
            <View>
              <Text style={{ fontSize: 12 }}>Envolve Outro Departamento: </Text>
              <Text style={{ fontSize: 12 }}>{json.departamento}</Text>
            </View>
          ) : json.envolveorgao === 'S' ? (
            <View>
              <Text style={{ fontSize: 12 }}>Envolve Outro Órgão: </Text>
              <Text style={{ fontSize: 12 }}>{json.orgao}</Text>
            </View>
          ) : null}
          <View>
            <Text style={{ fontSize: 12 }}>Prazo Inicial: </Text>
            <Text style={{ fontSize: 12 }}>{json.prazo} dias </Text>
          </View>
        </View>
      )}
    </View>
  );
};

export const RequestSolved = ({ movement, json, ...props }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Solucionada</Text>
      <Text style={styles.datetime}>{moment(movement.inicio).format('DD/MM/YYYY HH:mm:ss')}</Text>
      <View style={styles.normal}>
        <Text style={[styles.title, { fontSize: 14 }]}>Posicionamento:</Text>
        <Text style={{ fontSize: 12 }}>{movement.descricao}</Text>
      </View>
    </View>
  );
};

export const RequestCompleted = ({ movement, json, ...props }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Finalizada</Text>
      <Text style={styles.datetime}>{moment(movement.inicio).format('DD/MM/YYYY HH:mm:ss')}</Text>
      <View>
        {json.solucionada === 'S' ? (
          <Text style={{ fontSize: 12 }}>Situação: Solucionada</Text>
        ) : json.solucionada === 'N' ? (
          <Text style={{ fontSize: 12 }}>Situação: Não Solucionada</Text>
        ) : null}
      </View>
      <View style={styles.normal}>
        <Text style={[styles.title, { fontSize: 14 }]}>Posicionamento:</Text>
        <Text style={{ fontSize: 12 }}>{json.posicionamento}</Text>
      </View>
    </View>
  );
};

export const RequestAppeal = ({ movement, ...props }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Recurso</Text>
      <Text style={styles.datetime}>{moment(movement.inicio).format('DD/MM/YYYY HH:mm:ss')}</Text>
      <View>
        <Text style={{ fontSize: 12 }}>Motivo: </Text>
        <Text style={{ fontSize: 12 }}>{movement.descricao}</Text>
      </View>
    </View>
  );
};

export const RequestFooter = () => {
  return (
    <View style={{ marginTop: 15, marginLeft: 4 }}>
      <Text style={[styles.normal, { fontSize: 12 }]}>
        Prazo de resposta: 20 dias podendo haver uma prorrogação de 10 dias para o fornecimento de um parecer.
      </Text>
      {/*       <Text style={[styles.title, { marginTop: 15 }]}>Canais de resposta: </Text>
      <Text style={[styles.normal, { fontSize: 12 }]}>Site: -----</Text>
      <Text style={[styles.normal, { fontSize: 12 }]}>
        Presencialmente: Na Sala da Ouvidoria (localizada no Paço Municipal)
      </Text>
      <Text style={[styles.normal, { fontSize: 12 }]}>Telefone: (67)3238-1175</Text> */}
    </View>
  );
};
